import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKeyboard"><Path d="M8.5 13V21M15.5 13V21M6.5 3.5V12.5H10.5V3.5H6.5ZM13.5 3.5V12.5H17.5V3.5H13.5ZM3.5 3.5H20.5V21.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconKeyboard;
